module.exports = __webpack_public_path__ + "img/hero-planeta-periutelor-2.9d58fde6.png";